var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Star"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M4.71944 10.5076L4.04584 11.1987L4.71944 10.5076L1.57096 7.43863L5.92205 6.80638C6.41177 6.73522 6.83512 6.42764 7.05413 5.98388L9 2.04111L10.9459 5.98388C11.1649 6.42764 11.5882 6.73522 12.0779 6.80638L16.429 7.43863L13.2806 10.5076C12.9262 10.8531 12.7645 11.3507 12.8481 11.8385L13.5914 16.172L9.69966 14.126C9.26164 13.8957 8.73836 13.8957 8.30034 14.126L8.76568 15.0111L8.30034 14.126L4.4086 16.172L5.15186 11.8385C5.23551 11.3507 5.0738 10.8531 4.71944 10.5076Z",
    fill: "#F3C770",
    stroke: "#F3C770",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.f6ec7845838e451ed2fa96f29fa2167a.svg";
export { ForwardRef as ReactComponent };